import { v4 as uuid } from "uuid";
export const ENTITY_TYPES = ["socrat.file_voice"];
export const ENTITY_TYPES_FOR_NEURAL = ["socrat.text", "socrat.file_voice"];
const createNewNodeSource = (DocumentObjectId, AttributeValues) => {
    const Created = Date.now();
    const NodeId = uuid();
    return {
        Created,
        NodeId,
        DocumentObjectId,
        AttributeValues,
        LargeAttributeValues: {},
        PinnedToGroup: false,
        SourceCreated: Created
    };
};
export const createNodeSourceMap = (data) => data.reduce((acc, item) => {
    acc[item.NodeId] = item;
    return acc;
}, {});
export const createNewNodeSourceText = ({ text, tempText }) => createNewNodeSource("socrat.text", [
    {
        Key: "socrat.text",
        Value: text
    },
    {
        Key: "PT10000",
        Value: tempText
    }
]);
export const createNewNodeSourceFile = ({ fileLink, tempFileLink }) => createNewNodeSource("socrat.file", [
    {
        Key: "PT10001",
        Value: tempFileLink
    },
    {
        Key: "socrat.url",
        Value: fileLink
    }
]);
export const createNewNodeSourceFileTable = ({ fileLink }) => createNewNodeSource("socrat.table_document", [
    {
        Key: "PT10027",
        Value: fileLink
    }
]);
export const createNewNodeSourceVoice = ({ fileLink }) => createNewNodeSource("socrat.file_voice", [
    {
        Key: "PT50001",
        Value: fileLink
    }
]);
